import { faChevronLeft } from '@fortawesome/free-solid-svg-icons/faChevronLeft'
import classnames from 'classnames'
import React from 'react'
import { useSelector } from 'react-redux'

import { NAV_BRAND } from '@/config'
import { PORTAL_TYPE_RJA } from '@/config/constants'
import { JOB_LP } from '@/page/constants'
import { getPageType } from '@/page/store/selectors'

import { NavbarUpButton } from '../../generic'
import { getShowMobileSearchForm } from '../../search/store/selectors'
import useEventHandlers from '../hooks/useEventHandlers'

import MainMenuCloseButton from './MainMenuCloseButton'
import MainMenuLinks from './MainMenuLinks'
import MenuButtons from './MenuButtons'

const MainMenu = () => {
  const {
    open,
    toggleMainMenu,
    onNavigateUpClick,
    onShowSearchForm
  } = useEventHandlers()
  const isJobLandingPage = useSelector((state) => getPageType(state) === JOB_LP)
  const mobileSearchFormHidden = !useSelector(getShowMobileSearchForm)
  const isRJA = NAV_BRAND.portal_type === PORTAL_TYPE_RJA

  return (
    <div className={classnames('main-menu', {
      'mobile-search-form-hidden': isJobLandingPage && mobileSearchFormHidden
    })}
    >
      <div className='main-menu-container'>
        <nav className='navbar navbar-expand-xl navbar-light'>
          <NavbarUpButton icon={faChevronLeft} onClick={onNavigateUpClick} />
          <MenuButtons
            isJobLandingPage={isJobLandingPage}
            mobileSearchFormHidden={mobileSearchFormHidden}
            toggleMainMenu={toggleMainMenu}
            onShowSearchForm={onShowSearchForm}
          />

          {open && <div className='mobile modal-backdrop show' onClick={toggleMainMenu} />}
          <div className={classnames(
            'navbar-collapse offcanvas-collapse', { 'align-self-center justify-content-center': isRJA },
            { open, 'main-menu--left': isJobLandingPage, 'main-menu--right': !isJobLandingPage })}
          >
            <MainMenuCloseButton toggleMainMenu={toggleMainMenu} />
            <MainMenuLinks toggleMainMenu={toggleMainMenu} />
          </div>
          {isRJA && <div className='nav-right'> </div>}
        </nav>
      </div>
    </div>
  )
}

export default MainMenu
